export default "__VITE_ASSET__BCdOgFlY__"